import SimpleBar from "simplebar";
export function map() {
    const $mapSection = $(".map-section");
    const data = JSON.parse(JSON.stringify(mapData));
    const $window = $(window);
    let currentCountry = 0;
    const point = 1200;
    let isMobile = false;
    let isLoad = true;
    let isTimeout = null
    const $image = $mapSection.find(".map-image");
    const $points = $image.find(".points");
    let $pointItems = null;
    const pointIcon = $points.data("point-default");
    const $imageMapPath = $image.find(".image svg path");


    const $popup = $mapSection.find(".map-info");
    const $closePopup = $popup.find(".map-info-close");
    const $countriesNavigation = $popup.find(".countries-navigation");
    const $prevButton = $countriesNavigation.find(".prev");
    const $nextButton = $countriesNavigation.find(".next");
    const $selectedBlock = $popup.find(".selected");
    const $selectedCountry = $selectedBlock.children("span");
    const $openCountriesButton = $popup.find(".open-countries");
    const $descriptionCountry = $popup.find(".description");
    const $slider = $popup.find(".brands-slider");
    const $mapCountries = $popup.find(".map-countries");
    const $allCountries = $popup.find(".all-countries");
    document.addEventListener("DOMContentLoaded", () => {
        init();
    });
    // $window.on("load", function () {
    //     init();
    // });
    function init() {
        isMobile = checkMobile(point);
        if (data.length < 2) hideCountriesInfo();
        createMap();
        setActiveCountry(data[currentCountry].alpha2);
        setSelectedCountryAttributes()
        // if (!isMobile) closePopup();
        setEvents();
    }

    function checkMobile(point) {
        return $window.width() < point ? true : false;
    }

    function hideCountriesInfo() {
        $countriesNavigation.hide();
        $openCountriesButton.hide();
    }

    function setSelectedCountryAttributes() {
        if (isMobile) {
            $selectedCountry.attr("aria-hidden", "true").removeAttr("tabindex")
        } else {
            $selectedCountry.removeAttr("aria-hidden");

        }
    }

    function createMap() {
        let countryList = "";
        let pointsList = "";
        data.forEach(el => {
            let country = el.country.toUpperCase();
            if (el.alpha3) el.alpha2 = el.alpha2.toUpperCase();
            if (el.alpha3) el.alpha2 = el.alpha3.toUpperCase();
            countryList += createCountryItem(el);
            pointsList += createPoints(el);
            $imageMapPath.each(function () {
                const idPath = $(this).attr("id");
                const classPath = $(this).attr("class");
                const namePath = $(this).attr("name");
                if (idPath === el.alpha2 || classPath === el.country || namePath && namePath.toUpperCase() === country) {
                    $(this).attr("data-id", `${el.alpha2}`);
                }
                if (el.hasOwnProperty("countryGroup") && el.countryGroup.length > 0) {
                    for (let item of el.countryGroup) {
                        if (idPath === item.alpha2 || classPath && classPath.includes(item.country)) {
                            $(this).attr("data-id", `${el.alpha2}`);
                        }
                    }
                }
            });
        });
        $allCountries.append(createCountriesList(countryList));
        $points.append(pointsList);
        $pointItems = $points.find(".point");
    }

    function setEvents() {
        $window.on("resize", function () {
            const prevIsMobile = isMobile;
            isMobile = checkMobile(point);
            const $slides = $slider.find(".slide");
            if ($slides.length) {
                $slides.css("--min-height", `${$slider.innerWidth()}px`);
            }
            if (isMobile && $mapCountries.hasClass("show")) {
                $allCountries.css("--padding-top", `${$selectedBlock.innerHeight() + 10}px`);
            }
            if (prevIsMobile === isMobile) return;
            setActiveCountry(data[currentCountry].alpha2);
            setSelectedCountryAttributes()
            if (!isMobile) {
                // closePopup()

            } else {
                $image.removeAttr("style");
                $popup.removeAttr("style");
            }
        });
        $(document).on("keydown", function (event) {
            if (event.keyCode === 27 && !isMobile && $popup.hasClass("show")) closePopup();
        });

        $(".map-wrap").focusin(function (e) {
            if (!$(e.target).closest(".map-info").length && $popup.hasClass("show")) {
                $prevButton.focus();
            }
        });
        // $(document).on('keydown', function (e) {
        //     if (!$popup.is(e.target) && $popup.has(e.target).length === 0) {
        //         if (!isMobile && $popup.hasClass("show")) closePopup(false)
        //     }
        // });
        $pointItems.on("click", function (e) {
            if ($(this).hasClass("active")) return;
            const id = $(this).data("id");
            if (id) setActiveCountry(id);
        });
        $pointItems.on("mouseover", function (e) {
            const $point = $(this);
            if ($point.hasClass("point")) {
                const id = $point.data("id");
                $imageMapPath.filter(`[data-id="${id}"]`).addClass("hover");
            } else {
                $imageMapPath.removeClass("hover");
            }
        });
        $pointItems.on("mouseleave", function () {
            $imageMapPath.removeClass("hover");
        });
        $pointItems.on("focus", function () {
            const $point = $(this);
            const id = $point.data("id");
            $imageMapPath.filter(`[data-id="${id}"]`).addClass("hover");
        }).focusout(function () {
            $imageMapPath.removeClass("hover");
        });
        $allCountries.on("click", function (e) {
            e.preventDefault();
            if (!e.target.closest("li")) return;
            const id = $(e.target).parents("li").data("id");
            if (id) {
                setActiveCountry(id);
                $mapCountries.removeClass("show");
            }
        });
        $openCountriesButton.on("click", function () {
            if ($mapCountries.hasClass("show")) {
                $mapCountries.removeClass("show");
                isTimeout = setTimeout(() => {
                    $allCountries.removeAttr("style")
                }, 500);

            } else {
                $mapCountries.addClass("show");
                if (isTimeout) clearTimeout(isTimeout)
                $allCountries.removeAttr("style").css("--padding-top", `${$selectedBlock.innerHeight() + 10}px`);
            }

        });
        $prevButton.on("click", function () {
            const prev = (currentCountry > 0) ? data[currentCountry - 1] : data[data.length - 1];
            setActiveCountry(prev.alpha2);
            if (!isMobile) $popup.focus()

        });
        $nextButton.on("click", function () {
            const next = (currentCountry < data.length - 1) ? data[currentCountry + 1] : data[0];
            setActiveCountry(next.alpha2);
            if (!isMobile) $popup.focus();
        });
        $closePopup.on("click", function () {
            closePopup();
        });
    }

    function closePopup(focus = true) {
        $popup.removeClass("show");
        setTimeout(() => {
            $popup.css("display", "none");
        }, 500);
        $image.removeAttr("style");
        $imageMapPath.removeClass("active");
        $pointItems.removeClass("active");
        if ($mapCountries.hasClass("show")) $mapCountries.removeClass("show");
        if (!focus) return;
        $pointItems.filter(`[data-id="${data[currentCountry].alpha2}"]`).focus();
    }

    function showPopup(point) {
        $popup.removeAttr("style");
        setMapPosition(point);
        $popup.addClass("show");
        if (isLoad) return isLoad = false;
        if (!isMobile) $popup.focus();
    }

    function setActiveCountry(id) {
        const dataCountry = data.find((el, i) => {
            if (el.alpha2 === id) {
                currentCountry = i;
                return el.alpha2;
            }
        });

        controlSlider(dataCountry.brands);
        setAltLabelsOfButtons();
        $imageMapPath.removeClass("active");
        $imageMapPath.filter(`[data-id="${id}"]`).addClass("active");
        const $point = $points.find(`[data-id="${dataCountry.alpha2}"]`);
        $point.addClass("active").siblings().removeClass("active");
        $allCountries.find(`li[data-id="${dataCountry.alpha2}"]`).addClass("active").siblings().removeClass("active");
        $selectedCountry.text(dataCountry.title || dataCountry.country);
        if ($openCountriesButton.find("span").length) {
            $openCountriesButton.find("span").text(dataCountry.country);
        }
        $descriptionCountry.text(dataCountry.text);

        if (!isMobile) showPopup($point);
        const $slides = $slider.find(".item").children();
        // add images in slider
        $slides.each(function (i) {
            const dataImg = dataCountry.brands[i]
            $(this).append(`<img class="dark" src="${dataImg.url}" alt="${dataImg.text}"/>`);
        });
        setTimeout(function () {
            $("body").find("#brands-slider .simplebar-content-wrapper").removeAttr("tabindex");
        }, 500);

        // $prevButton.focus();
    }

    function setMapPosition(point) {
        const popupPosition = $popup.offset().left + $popup.width() + 200;
        const pointPosition = point.offset().left;
        if (popupPosition > pointPosition) {
            $image.css("transform", `translateX(${popupPosition - pointPosition}px)`);
        } else {
            $image.removeAttr("style");
        }
    }

    function setAltLabelsOfButtons() {
        const nextCountry = (currentCountry === data.length - 1) ? data[0].country : data[currentCountry + 1].country;
        const prevCountry = (currentCountry === 0) ? data[data.length - 1].country : data[currentCountry - 1].country;
        $nextButton.attr("aria-label", `View ${nextCountry}`);
        $prevButton.attr("aria-label", `View ${prevCountry}`);
    }

    function controlSlider(items) {
        if ($slider.hasClass("slick-initialized")) {
            $slider.slick("unslick");
        }
        $slider.html("").append(createSlides(items));
        if (!isMobile) return new SimpleBar(document.getElementById("brands-slider"), {autoHide: false});
        $slider.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            infinite: false,
            dots: true,
            arrows: false,
        });
    }

    function createSlides(items) {
        const size = 9;
        let arraySlides = [];
        const arrayItems = items.map(el => `
            <div class="item">
            <${el.href ? "a" : "div"} class="image-wrapper" ${el.href ? 'target="_blank"' + "href=" + el.href : ""}>
                </${el.href ? "a" : "div"}>
            </div>

        `);
        for (let i = 0; i < Math.ceil(arrayItems.length / size); i++) {
            arraySlides[i] = arrayItems.slice((i * size), (i * size) + size).join("");
        }
        return arraySlides.map(el => `<div class="slide" style="--min-height: ${$slider.innerWidth()}px">${el}</div>`).join("");
    }

    function createPoints(props) {
        const {left, top, alpha3, alpha2, country} = props;
        return `
        <button class="point" aria-label="${country}" data-id="${alpha2}" style="left: ${left}; top:${top}">
            <span>${alpha3 ? alpha3 : alpha2}</span>
            <img src="${pointIcon}" alt="">
        </button>`;
    }

    function createCountriesList(list) {
        return `<ul class="countries-list is-scroll">
            ${list}
        </ul>`;
    }

    function createCountryItem(props) {
        const {alpha2, country} = props;
        return `<li data-id="${alpha2}"><a href="#"  >${country}</a></li>`;
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/map.js